import type { ProductTitleProps } from '@components/ProductTitle';
import { useProductItemThemeSettings } from '@providers/ThemeProvider/Provider/ProductItemThemeSettings';
import { useMemo } from 'react';

export type ProductTitlePropsMapSettings = Pick<
  ProductTitleProps,
  'color' | 'fontSize' | 'textAlign' | 'fontStyle' | 'fontFamily' | 'fontWeight' | 'textTransform'
>;

export const useConnectProductTitle = () => {
  const settings = useProductItemThemeSettings();
  const productTitleSettings = settings.productInfo?.elements?.title;

  const props: ProductTitlePropsMapSettings = useMemo(() => {
    return productTitleSettings || {};
  }, [productTitleSettings]);

  return {
    props,
  };
};
